"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _react2 = require("@chakra-ui/react");

var __jsx = _react["default"].createElement;

var BlockSpacerChakra = function BlockSpacerChakra(_ref) {
  var block = _ref.block;
  return __jsx(_react2.Box, {
    height: block.content.height
  });
};

var _default = BlockSpacerChakra;
exports["default"] = _default;